export const searchItem = (id, title, city, link, categories, lat, lng, lang) => {
    if (lat === null || lng === null) return
    let cats
    if (categories) {
        cats = categories
            .map((cat) => {
                return cat
            })
            .join(', ')
    }

    return /*html*/ `
    <div 
        class="map-search-item vit mb-12 py-12 px-16 radius"
        title="${title}"
        data-lat="${lat}"
        data-lng="${lng}"
        data-id="${id}"
        >
        <div>
            <h4 class="mb-8"><strong>${title}</strong></h4>
            <div class="small d-flex align-items-center">
                <span class="material-icons-round me-8">place</span> ${city}
                ${cats ? `<span class="material-icons-round ms-16">store</span> <span class="ms-8">${cats}</span>` : ''}
            </div>
        </div>
    </div>
`
}
